<template>
	<el-date-picker v-model="times" type="datetime" :placeholder="placeholder" :size="$store.state.isphone?'mini':''" style="width: 100%;"></el-date-picker>
</template>

<script>
	export default {
		data() {
			return {
				
			}
		},
		methods:{
			
		},
		props: {
			value: {
				type: [String,Number],
				default: ''
			},
			placeholder: {
				type: String,
				default: ''
			}
		},
		mounted: function () {
			
		},
		computed:{
			times: {
				get () {
					if(this.value==null||this.value=='')
					{
						return null;
					}
					else
					{
						return new Date(Number(this.value)*1000);
					}
				},
				set (value) {
					if(value==null)
					{
						var o=document.createElement('input');
						o.input=()=>{
							this.$emit('input', null);
						}
						o.input();
					}
					else
					{
						var o=document.createElement('input');
						o.input=()=>{
							this.$emit('input', (value.getTime()/1000).toFixed(0));
						}
						o.input();
					}
				}
			}
		}
	}
</script>

<style>
</style>
